import { makeStyles, tokens, shorthands } from '@fluentui/react-components';
import { fontScale } from '@/theme';
import { mq } from '../../theme/scalingTokens';

export const useConfirmationStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    ...shorthands.padding('2rem', '1.5rem'),
    rowGap: '0.75rem',
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.borderRadius('1rem'),
    boxShadow: tokens.shadow4,
    [mq.tablet]: {
      ...shorthands.padding('1.5rem', '1.25rem'),
      ...shorthands.borderRadius('0.75rem'),
    },
    [mq.mobile]: {
      ...shorthands.padding('1.25rem', '1rem'),
      ...shorthands.borderRadius('0.5rem'),
    },
  },
  /**
   * Figma 2026 Confirmation hero (node `1-4`): centred green check icon,
   * white surface with neutral 1 px border, 8 px radius.
   */
  rootFigma: {
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.border('1px', 'solid', tokens.colorNeutralStroke1),
    ...shorthands.borderRadius('0.5rem'),
    ...shorthands.padding(tokens.spacingVerticalXXL, tokens.spacingHorizontalXXL),
    boxShadow: 'none',
  },
  successIconFigma: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '3.5rem',
    height: '3.5rem',
    backgroundColor: tokens.colorPaletteGreenForeground1,
    color: tokens.colorNeutralBackground1,
    ...shorthands.borderRadius('0.5rem'),
    marginBottom: tokens.spacingVerticalS,
  },
  title: {
    fontSize: fontScale.title,
    fontWeight: '700',
    color: tokens.colorNeutralForeground1,
    lineHeight: '1.3em',
    [mq.mobile]: {
      fontSize: fontScale.subtitle,
    },
  },
  message: {
    fontSize: fontScale.body,
    color: tokens.colorNeutralForeground2,
    maxWidth: '37.5rem',
    lineHeight: '1.43em',
  },
  actions: {
    display: 'flex',
    gap: '0.75rem',
    marginTop: '0.5rem',
    flexWrap: 'wrap',
    justifyContent: 'center',
    [mq.mobile]: {
      flexDirection: 'column',
      width: '100%',
    },
  },
});
